
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beneficiary",
      function () {
        return require("private-next-pages/beneficiary/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beneficiary"])
      });
    }
  